import './problems.component.scss'

import Swiper, { Navigation } from 'swiper'

import 'swiper/css'
import 'swiper/css/navigation'

class ProblemsGal {
  constructor(elements, settings) {
    this.elements = elements
    this.settings = settings

    this.init()
  }

  defineMedia() {
    this.media = {
      query: `(min-width: ${this.settings.breakpoint}px)`
    }
    this.media.watcher = window.matchMedia(this.media.query)
  }

  defineSlider() {
    this.slider = new Swiper(this.elements.wrap, {
      modules: [Navigation],
      navigation: this.elements.navigation,
      slidesPerView: 1.5,
      spaceBetween: 8,
      loop: true,
      breakpoints: {
        375: {
          slidesPerView: 2.5,
          spaceBetween: 8,
        },
        667: {
          slidesPerView: 3.5,
          spaceBetween: 16,
        }
      }
    })
  }

  firstToggle() {
    if (window.innerWidth < this.settings.breakpoint) {
      this.defineSlider()
    } else {
      this.elements.arrowsWrap.classList.add('hidden')
    }
  }

  defineToggle() {
    this.media.watcher.addEventListener('change', event => {
      if (!event.matches) {
        this.defineSlider()
        this.elements.arrowsWrap.classList.remove('hidden')
      } else {
        if (this.slider) {
          this.slider.destroy()
          this.slider = null
          this.elements.arrowsWrap.classList.add('hidden')
        }
      }
    })
  }

  init() {
    this.defineMedia()

    this.firstToggle()
    this.defineToggle()
  }
}

const problemsSlidersList = document.querySelectorAll('.problems-gal.swiper')
problemsSlidersList.forEach(galEl => {
  new ProblemsGal({
    wrap: galEl,
    arrowsWrap: galEl.querySelector('.problems-arrows'),
    navigation: {
      prevEl: galEl.querySelector('.problems-arrows__arrow-prev'),
      nextEl: galEl.querySelector('.problems-arrows__arrow-next')
    }
  }, {
    breakpoint: 1024
  })
})